import React from 'react'

function FileXMarkIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M4.75 6.75a4 4 0 0 1 4-4h5.555a1 1 0 0 1 .743.331l3.945 4.384a1 1 0 0 1 .257.669v9.116a4 4 0 0 1-4 4h-6.5a4 4 0 0 1-4-4V6.75Z"
      />
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M13.25 2.75v2a4 4 0 0 0 4 4h2M9.5 16.75l2.5-2.5m0 0 2.5-2.5m-2.5 2.5-2.5-2.5m2.5 2.5 2.5 2.5"
      />
    </svg>
  )
}
export default FileXMarkIcon
